
  var _styles = {
  "city-explore-root": {
    "width": "10rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "city-explore-loading": {
    "width": "9.36rem",
    "height": "6.72rem"
  }
};



  module.exports = _styles;
  